import React, { useState } from 'react'
import { Button } from '../../atoms'
import Link from 'next/link'
import useTrans from '../../../hooks/useTrans'

const NonHaiTrovatoBox = ({}) => {
  const t = useTrans()
  return (
    <div className="nonhaitrovato">
      <div className="w-container">
        <div className="nonhaitrovato__content">
          <p className="nonhaitrovato__title">{t('Non hai trovato quello che stai cercando?')}</p>
          <p className="nonhaitrovato__description">
            {t('Contattaci per ricevere asistenza oppure richiedi il tuo ordine personalizzato')}
          </p>

          <div className="nonhaitrovato__buttons">
            <Link legacyBehavior href="/contatti">
              <a>
                <Button
                  variant="secondary"
                  colorVariant="black"
                  label={t('Contattaci')}
                  size="large"
                  responsive={true}
                  className="nonhaitrovato__button"
                />
              </a>
            </Link>
            {/*
            <Link legacyBehavior  href="#TODO">
              <Button 
                variant="secondary" 
                colorVariant="black" 
                label={t("Richiedi ordine Taylor Made")} 
                size="large" 
                responsive={true}
                className="nonhaitrovato__button"
              />
            </Link>
            */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default NonHaiTrovatoBox
